import { render, staticRenderFns } from "./NBC33.vue?vue&type=template&id=08b0ae4e&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./NBC33.vue?vue&type=script&lang=js&"
export * from "./NBC33.vue?vue&type=script&lang=js&"
import style0 from "./NBC33.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports